import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useSaveCandidateFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.candidatesSaveFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.candidatesFilters]);
    },
  });
};
